import React from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Progress } from '../ui/progress';
import { QuizOption } from './QuizOption';

export const QuizQuestion = ({ 
  question, 
  currentIndex, 
  totalQuestions, 
  selectedOptions, 
  onOptionSelect, 
  onNext, 
  onBack 
}) => {
  const progress = ((currentIndex + 1) / totalQuestions) * 100;
  const IconComponent = question.icon;

  return (
    <Card className="max-w-2xl mx-auto">
      <CardHeader>
        <div className="flex items-center justify-between mb-4">
          <CardTitle className="text-2xl">Free Roof Assessment</CardTitle>
          <span className="text-sm text-gray-500">
            Question {currentIndex + 1} of {totalQuestions}
          </span>
        </div>
        <Progress value={progress} className="h-2" />
      </CardHeader>
      <CardContent>
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <IconComponent className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900">{question.question}</h3>
          </div>

          <div className="space-y-3">
            {question.options.map((option) => (
              <QuizOption
                key={option.value}
                option={option}
                isSelected={selectedOptions.includes(option.value)}
                onClick={onOptionSelect}
              />
            ))}
          </div>

          {question.multiple && (
            <p className="text-sm text-gray-500 mt-4">
              * You can select multiple options
            </p>
          )}
        </div>

        <div className="flex space-x-3">
          {currentIndex > 0 && (
            <Button
              onClick={onBack}
              variant="outline"
              className="flex-1"
              data-testid="quiz-back-btn"
            >
              <ChevronLeft className="w-4 h-4 mr-2" />
              Back
            </Button>
          )}
          <Button
            onClick={onNext}
            className="flex-1 bg-primary hover:bg-accent"
            data-testid="quiz-next-btn"
          >
            {currentIndex === totalQuestions - 1 ? 'See Results' : 'Next'}
            <ChevronRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
